import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

const Component = ({ label = '', controlId = '', type = '', disabled = false, ...props }) => {
  return (
    <Form.Group className="mb-2" controlId={controlId}>
      <Form.Check
        className={`text-sm text-font-inputText tracking-wide ${
          disabled == true ? 'cursor-not-allowed' : 'cursor-pointer'
        }`}
        type={type}
        label={label}
        disabled={disabled}
        {...props}
      />
    </Form.Group>
  );
};

Component.propTypes = {
  label: PropTypes.string,
  controlId: PropTypes.string,
  type: PropTypes.string
};

export default Component;
